import { render } from "./ClientDashboard.vue?vue&type=template&id=9e86d020"
import script from "./ClientDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/ClientDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e86d020"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e86d020', __exports__)) {
    api.reload('9e86d020', __exports__)
  }
  
  module.hot.accept("./ClientDashboard.vue?vue&type=template&id=9e86d020", () => {
    api.rerender('9e86d020', render)
  })

}


export default __exports__